module.exports = {
    get defaultFontSize() {
        var defaultFontSize = parseInt($('html').css('font-size'));
        if (isNaN(defaultFontSize)) defaultFontSize = 16;
        return defaultFontSize;
    },
    get mobile() {
        return 20 * this.defaultFontSize;
    },
    get mobileBig() {
        return 28 * this.defaultFontSize;
    },
    get tablet() {
        return 48 * this.defaultFontSize;
    },
    get tabletBig() {
        return 60 * this.defaultFontSize;
    },
    get desktop() {
        return 76.5 * this.defaultFontSize;
    }
};



// WEBPACK FOOTER //
// ./modules/size.js